export class SentenceFormatter {
  /**
   * Returns a sentence piece composed of the given {@link names}.
   * @param names The names of the persons. For example `["Georges R. R. Martin", "J. K. Rowling", "Jeanne d'Arc"]`.
   *
   * @example
   * // Example 1
   * const personSentence = SentenceFormatter.personList(["Georges R. R. Martin", "J. K. Rowling", "Jeanne d'Arc"]);
   * console.log(personSentence); // Georges R. R. Martin, J. K. Rowling et Jeanne d'Arc
   *
   * // Example 2
   * const personSentence = SentenceFormatter.personList(["Jeanne d'Arc"]);
   * console.log(personSentence); // Jeanne d'Arc
   */
  static personList(names: (string | undefined)[]): string {
    // Skip missing names: dry UserAct entities built from IRIs may have no fullname.
    const validNames = names.filter((name): name is string => name !== undefined && name !== '');
    if (validNames.length === 0) return '';
    if (validNames.length === 1) return validNames[0];
    return `${validNames.slice(0, -1).join(',')} et ${validNames.at(-1)}`;
  }
}
